<template>
    <v-card>

        <v-card-title class="dialog-header">
            <span class="headline" v-if="toggleAdd">{{ $t("addDeliveryAcceptance") }}</span>
            <span class="headline" v-if="!toggleAdd">{{$t("editDeliveryAcceptance")}}</span>
            <v-spacer></v-spacer>
            <v-btn
                fab
                text
                icon
                @click="handleClose"
                valid="false"
                v-shortkey="['esc']"
                @shortkey.native="handleClose"
            >
                <v-icon dark>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text>
                <v-form v-model="valid" ref="formData">
                <v-overlay :value="overlay"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
                <v-row>
                    <v-col cols="12" sm="3" md="3" class="seperate-line-verticle">
                        <v-row>
                            <v-col v-if="userDoc.type === 'employee'" cols="12" sm="12" md="12">
                                <v-text-field
                                    dense
                                    outlined
                                    disabled
                                    v-model="formDoc.client_name"
                                    :label="$t('client') + '*'"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <v-text-field
                                    dense
                                    disabled
                                    outlined
                                    v-model="formDoc.supplier_name"
                                    :label="$t('supplier') + '*'"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <v-select
                                    :items="currencyOptionList"
                                    :label="$t('currency')"
                                    outlined
                                    v-model="formDoc.currency_code"
                                    disabled
                                    item-text="text"
                                    item-value="id"
                                    dense
                                ></v-select>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <v-menu
                                    v-model="menuDate"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="formDoc.date"
                                            :label="$t('acceptanceDate') + '*'"
                                            prepend-inner-icon="mdi-calendar"
                                            outlined
                                            dense
                                            readonly
                                            :rules="dateRules"
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        :first-day-of-week="0"
                                        v-model="formDoc.date"
                                        :rules="dateRules"
                                        @input="menuDate = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="formDoc.reference"
                                    :label="$t('reference')"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="formDoc.delivery_name"
                                    :label="$t('deliveryName') + '*'"
                                    :rules="requireRules"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="formDoc.driver_phone"
                                    :label="$t('driverPhone') + '*'"
                                    type="number"
                                    prefix="+855"
                                    required
                                    :rules="phoneRules"

                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="formDoc.truck_plate_number"
                                    :label="$t('truckPlateNumber')"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="12" sm="9" md="9">
                        <v-row>
                            <v-col cols="12" md="12" sm="12">
                                <v-data-table
                                    :headers="transaction_line_header"
                                    :items="transaction_line"
                                    hide-default-footer
                                    mobile-breakpoint="0"
                                >
                                    <template v-slot:header.name="{ header }">{{ $t(header.text) }}</template>
                                    <template v-slot:header.delivery_qty="{ header }">{{ $t(header.text) }}</template>
                                    <template v-slot:header.qty="{ header }">{{ $t(header.text) }}</template>
                                    <template v-slot:header.price="{ header }">{{ $t(header.text) }}</template>
                                    <template v-slot:header.sub_total="{ header }">{{ $t(header.text) }}</template>
                                    <template v-slot:header.action="{  }">
                                        <v-checkbox
                                            v-model="checkAll" @change="toggleCheckAll"
                                            color="success"
                                            hide-details
                                        ></v-checkbox>
                                    </template>
                                    <template v-slot:item.qty="{ item }">
                                        <v-text-field
                                            style="min-width: 150px"
                                            type="number"
                                            v-model="item.qty"
                                            @change.native="updateDeliveryAcceptanceLine(item)"
                                            @keyup.native="updateDeliveryAcceptanceLine(item)"
                                            hide-details="auto"
                                            :max="item.order_qty"
                                            min="0"
                                            :suffix="item.unit_name"
                                            dense
                                        ></v-text-field>
                                    </template>
                                    <template v-slot:item.price="{ item }">{{ item.price | formatNumber }}</template>
                                    <template v-slot:item.sub_total="{ item }">{{ item.sub_total | formatNumber }}</template>
                                    <template v-slot:item.action="{ item }">
                                        <v-checkbox
                                            v-model="item.isCheck"
                                            @change="toggleDeliveryAcceptanceLine(item)"
                                            hide-details
                                        ></v-checkbox>
                                    </template>
                                </v-data-table>
                            </v-col>

                            <v-col sm="8" cols="2" style="text-align: right;"><h3>{{ $t("totalAmount") }} :</h3></v-col>
                            <v-col cols="10" sm="4" style="font-weight: bold;font-size: 25px">{{ formDoc.total_amount | formatNumber }}{{currency_symbol}}</v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea
                                    clearable
                                    outlined
                                    :placeholder="$t('yourDesc')"
                                    v-model="formDoc.note"
                                    clear-icon="mdi-close-circle"
                                    rows="3"
                                    auto-grow
                                    :label="$t('note')"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                </v-form>
        </v-card-text>
        
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="reset">Reset</v-btn>
            <v-btn rounded @click="submit($event,false,true)" style="min-width: 150px" color="primary">
                <font-awesome-icon icon="check-circle" class="mr-2"/>
                {{$t("saveAndPaid")}}
            </v-btn>

            <v-btn rounded @click="submit($event,true)" style="min-width: 150px" color="warning">
                <font-awesome-icon icon="check-circle" class="mr-2"/>
                {{$t("saveAndPrint")}}
            </v-btn>

            <v-btn rounded @click="submit($event,false)" style="min-width: 150px" color="success">
                <font-awesome-icon icon="check-circle" class="mr-2"/>
                {{$t("save")}}
            </v-btn>
        </v-card-actions>
    </v-card>

</template>
<script>

    import OptionDataMixin from "../../../mixins/optionDataMixin";
    import MainMixin from "../../../mixins/mainMixin";
    import ValidatorMixin from "../../../mixins/validatorMixin";
    import moment from "moment";
    import {provider} from "@/service/provider";
    import axios from "axios";

    export default {
        mixins: [OptionDataMixin, MainMixin, ValidatorMixin],
        components: {},
        props: ["deliveryDoc", "isEdit"],
        name: "deliveryAcceptance",
        data() {
            return {

                checkAll: false,
                dialogDetail: false,
                detailDoc: {},
                overlay: false,
                page: 1,
                formDoc: {
                    id: "",
                    transaction_order_id: "",
                    business_id: "",
                    supplier_id: "",
                    client_id: "",
                    time: "",
                    date: moment().format("YYYY-MM-DD"),
                    type: "",
                    reference: "",
                    total_amount: 0,
                    paid_amount: 0,
                    balance: 0,
                    currency_code: "",
                    note: "",
                    supplier_name: "",
                    delivery_name: "",
                    driver_phone: "",
                    truck_plate_number: "",
                    user_id: "",
                    payment_method: "cash",
                    wallet_account: "",
                    duration: "",
                    duration_period: "per_month",
                    interest_rate: "",
                    total_interest: 0,
                    client_account_no: ""
                },
                transaction_line: [
                    // {variation_id: "", name: "Rice", qty: 10, price: 5000, amount: 50000.3345},
                ],
                transaction_line_header: [
                    {
                        text: "productName",
                        align: "start",
                        sortable: false,
                        value: "name"
                    },
                    {text: "price", value: "price", sortable: false},
                    {text: "deliveryQty", value: "delivery_qty", width: 150, sortable: false},
                    {text: "acceptanceQty", value: "qty", width: 150, sortable: false},
                    {text: "amount", value: "sub_total", sortable: false},
                    {text: "action", value: "action", sortable: false, width: 50}
                ],
                supplierDoc: {},
                currency_symbol: "",
                tmpTotalAmount: 0
            };
        },
        methods: {
            handleDeliverAcceptance(doc) {
                let vm = this;
                if (this.isEdit === false) {
                    vm.toggleAdd = true;
                    vm.formDoc = doc;
                    vm.formDoc.payment_method = "cash";
                    vm.formDoc.date = moment().format("YYYY-MM-DD");
                    vm.formDoc.id = "";
                    vm.formDoc.reference = "";
                    vm.formDoc.driver_phone = doc.driver_phone.replace("+855", "");
                    vm.transaction_line = [];
                    doc.transaction_delivery_line.forEach((d) => {
                        d.currency_code = vm.formDoc.currency_code;
                        d.currency_symbol = vm.getCurrencySymbol(vm.formDoc.currency_code);
                        d.delivery_qty = parseFloat(d.qty);
                        d.qty = 0;
                        d.price = parseFloat(d.price);
                        d.sub_total = 0;
                        d.transaction_line_id = "";
                        vm.transaction_line.push(d);
                    })
                } else {
                    vm.toggleAdd = false;
                    vm.formDoc = doc;
                    vm.transaction_line = [];
                    vm.transaction_line.push(...doc.transaction_line);
                    vm.transaction_line.map((d) => {
                        d.currency_code = vm.formDoc.currency_code;
                        d.currency_symbol = vm.getCurrencySymbol(vm.formDoc.currency_code);
                        d.delivery_qty = parseFloat(d.delivery_qty);
                        d.qty = parseFloat(d.qty);
                        d.price = parseFloat(d.price);
                        d.sub_total = d.price * d.qty;
                        d.transaction_line_id = d.transaction_line_id || "";
                        return d;
                    })
                }
                vm.$nextTick(() => {
                    vm.calculateTotal();

                });
            },
            handleClose(d) {
                let vm = this;
                vm.$emit("handleCreateDeliveryAcceptance", d);
            },
            submit(event, isPrint, isPayment) {
                let vm = this;
                event.preventDefault();
                if (vm.$refs.formData.validate()) {
                     /** Check each item line */
                   if(vm.transaction_line.filter(obj => { return obj.qty > 0 }).length){

                        vm.overlay = true;
                        vm.formDoc.user_id = localStorage.id;
                        vm.transaction_line.map((d) => {
                            d.qty = parseFloat(d.qty);
                            d.price = parseFloat(d.price);
                            d.sub_total = parseFloat(d.sub_total);
                            return d;
                        })
                        vm.formDoc.note = vm.formDoc.note || "";
                        vm.formDoc.transaction_line = vm.transaction_line;
                        let newFormDoc = Object.assign({}, vm.formDoc);
                        newFormDoc.date = vm.parseToDate(vm.formDoc.date);
                        newFormDoc.driver_phone = "+855" + newFormDoc.driver_phone;
                        let url = provider.baseURL + provider.storeTransaction;
                        return new Promise((resolve, reject) => {
                            axios.post(url, newFormDoc, {headers: {Authorization: localStorage.token}}).then(
                                res => {
                                    if (res.data.response && res.data.response.code === 200) {
                                        resolve(res.data.data.transaction_invoice_id);
                                        vm.$notify({
                                            title: "Success",
                                            message: vm.$t("success"),
                                            type: "success",
                                            duration: 700
                                        });
                                        vm.dialog = false;
                                        if (isPrint === true) {
                                            vm.$router.push({
                                                name: 'beeshop.agri-input.order-management.print-invoice-shop',
                                                params: {id: res.data.data.transaction_invoice_id, type: "purchase_order", back: 'beeshop.agri-input.order-management.delivery-board'}
                                            })
                                            vm.handleClose();

                                        } else if (isPayment === true) {
                                            let d = {};
                                            d.isPayment = isPayment;
                                            d.transaction_id = res.data.data.transaction_invoice_id;
                                            vm.handleClose(d);

                                        } else {
                                            vm.handleClose();
                                        }
                                        vm.overlay = false;

                                    } else if (res.data.response && res.data.response.code === 300) {
                                        vm.$notify({
                                            title: "Error",
                                            message: res.data.response.message,
                                            type: "error",
                                            duration: 1200
                                        });
                                    }
                                    vm.overlay = false;
                                },
                                error => {
                                    reject(error);
                                    vm.overlay = false;

                                }
                            );
                        });

                    }
                    else {
                        vm.$notify({
                            title: "Error",
                            message: vm.$t("pleaseCheckProductDeliveryAcceptance"),
                            type: "error",
                            duration: 2000
                        });
                   }
                }
            },
            updateDeliveryAcceptanceLine(row) {
                let vm = this;
                let newDoc = row;
                let index = vm.transaction_line.findIndex(
                    ind => ind.product_id === row.product_id
                );
                newDoc.sub_total =
                    parseFloat(newDoc.qty) * parseFloat(newDoc.price);
                vm.transaction_line[index] = newDoc;

                vm.$nextTick(() => {
                    vm.calculateTotal();
                });
            },
            toggleDeliveryAcceptanceLine(row) {
                let vm = this;
                if (row.isCheck) {
                    let newDoc = row;
                    let index = vm.transaction_line.findIndex(
                        ind => ind.product_id === row.product_id
                    );
                    newDoc.qty = newDoc.delivery_qty;
                    newDoc.sub_total =
                        parseFloat(newDoc.qty) * parseFloat(newDoc.price);

                    vm.transaction_line[index] = newDoc;

                    let unCheckDoc = vm.transaction_line.find(o => o.isCheck === false);
                    if (!unCheckDoc) {
                        vm.checkAll = true;
                    }
                } else {
                    let newDoc = row;
                    let index = vm.transaction_line.findIndex(
                        ind => ind.product_id === row.product_id
                    );
                    newDoc.qty = 0;
                    newDoc.sub_total =
                        parseFloat(newDoc.qty) * parseFloat(newDoc.price);

                    vm.transaction_line[index] = newDoc;
                    vm.checkAll = false;
                }
                vm.$nextTick(() => {
                    vm.calculateTotal();
                });
            },
            calculateTotal() {
                let vm = this;
                vm.formDoc.total_amount = 0;
                if (vm.transaction_line && vm.transaction_line.length > 0) {
                    vm.transaction_line.forEach((obj) => {
                        vm.formDoc.total_amount += parseFloat(obj.sub_total);
                    })
                }
            },
            toggleCheckAll(val) {
                let vm = this;
                vm.transaction_line.forEach((obj) => {
                    obj.isCheck = val;
                    vm.toggleDeliveryAcceptanceLine(obj);

                })
            },

        },
        watch: {
            "formDoc.driver_phone"(val) {
                let vm = this;
                if (val) {
                    vm.formDoc.driver_phone = parseInt(val);
                }
            },
            "formDoc.currency_code"(val) {
                let vm = this;
                vm.currency_symbol = vm.getCurrencySymbol(val);
            }
        },
        computed: {
            userDoc() {
                return this.$store.state.userDoc;
            },
            balance() {
                return (this.formDoc.total_amount || 0) - (this.formDoc.paid_amount || 0)
            }
        },
        created() {
            let vm = this;
            vm.handleDeliverAcceptance(this.deliveryDoc);
            vm.fetchCurrencyOption();
            vm.formDoc.duration_period = "per_month";

            let url = provider.baseURL + provider.getListSupplier;
            return new Promise((resolve, reject) => {
                axios.post(url, {
                    id: this.deliveryDoc.supplier_id,
                    search: "",
                    parent_id: "",
                    client_type: "",
                    offset: 0,
                    limit: 1,
                }, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.supplierDoc = res.data.data && res.data.data[0] || {};
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });
        }
    };
</script>
